const filteredItems = [
  {
    id: 'all',
    label: 'global.filter.all',
  },
  {
    id: 'Scheduled',
    label: 'global.scheduled2',
  },
  {
    id: 'NotScheduled',
    label: 'global.notScheduled',
  },
]

export default filteredItems
